import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseHttpService } from '@api/base-http.service';
import { Branch, BranchContact, BranchCreate, BranchUpdate, DoctorBranch, DoctorBranchCreate } from '@dto/Branch';

@Injectable({ providedIn: 'root' })
export class BranchApiService extends BaseHttpService {
  constructor(http: HttpClient) {
    super(http, 'branch');
  }

  list(): Promise<Branch[]> {
    return this.get<Branch[]>({});
  }

  listContacts(): Promise<BranchContact[]> {
    return this.get<BranchContact[]>({}, '/contacts');
  }

  createBranch(dto: BranchCreate): Promise<Branch> {
    return this.post<BranchCreate, Branch>(dto);
  }

  updateBranch(dto: BranchUpdate): Promise<void> {
    return this.patch<BranchUpdate, void>(dto);
  }

  removeBranch(id: number): Promise<void> {
    return this.delete('/' + id);
  }

  getDoctorBranches(doctorId: number): Promise<DoctorBranch[]> {
    return this.get<DoctorBranch[]>({}, '/doctor/' + doctorId);
  }

  getBranchDoctors(branchId: number): Promise<DoctorBranch[]> {
    return this.get<DoctorBranch[]>({}, '/' + branchId + '/doctors');
  }

  upsertMembership(dto: DoctorBranchCreate): Promise<DoctorBranch> {
    return this.post<DoctorBranchCreate, DoctorBranch>(dto, '/doctor');
  }

  removeMembership(doctorId: number, branchId: number): Promise<void> {
    return this.delete(`/doctor/${doctorId}/${branchId}`);
  }
}
